import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import Space from "Components/Space";
import DotsIcon from "Assets/SVG/DotsIcon";
import {useProjects} from "../../Apis/ProjectApi";
import {ProjectSettlementDto} from "../../Apis/Models/ProjectSettlementDto";
import moment from "moment";
import DownloadIcon from "../../Assets/SVG/DownloadIcon";
import { saveAs } from 'file-saver';
import {useDownloadSettlementPdf, useReopenSettlement} from '../../Apis/ProjectSettlementApi';
import useToasts from "../../Hooks/UseToasts";
import XIcon from "../../Assets/SVG/XIcon";
import Confirmation from "../../Components/Confirmation";

interface IProps {
    projectSettlements?: ProjectSettlementDto[];
    isLoading: boolean;
}
const ProjectSettlementList = (props: IProps) => {
    
    const { showSuccessToast } = useToasts();

    const { t } = useTranslation();
    
    const { projectSettlements, isLoading } = props;

    const { data: projects } = useProjects({includeAll: true})
    
    const navigate = useNavigate();

    const { mutateAsync: downloadSettlement } = useDownloadSettlementPdf();
    const { mutateAsync: reopenSettlement } = useReopenSettlement();

    const download = async (projectSettlement: ProjectSettlementDto) => {
        showSuccessToast(t('downloading'));

        const responseBlob = await downloadSettlement(projectSettlement.id)

        const blob = new Blob([responseBlob], {type: 'application/pdf' });

        const project = projects!.items.filter(x => x.id === projectSettlement.projectId)[0];

        saveAs(blob, `${project.name} - ${projectSettlement.from} / ${projectSettlement.to}.pdf`);
    }
    
    const reopen = async ( projectSettlement: ProjectSettlementDto)=> {
        await reopenSettlement(projectSettlement.id);
        
        showSuccessToast(t('reopened'));
    }

    return (
        <List<ProjectSettlementDto> data={projectSettlements} loading={isLoading} columns={[
            {
                title: t('project'),
                textRender: (record) => projects ? projects.items.find(x => x.id === record.projectId)?.name ?? '' : ''
            },
            {
                title: t('period'),
                textRender: (record) => `${moment(record.from).format('DD-MM-YYYY')} - ${moment(record.to).format('DD-MM-YYYY')}`
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) =>(
                    <Space size={"medium"} direction={"horizontal"} align={"center"}>
                        {record.id && (
                            <Confirmation trigger={
                                <FlexRow>
                                    <XIcon />
                                </FlexRow>
                            } text={t('reopenSettlementConfirmation')} onConfirm={() => reopen(record)} />
                        )}

                        {record.id && (
                            <FlexRow onClick={() => download(record)}>
                                <DownloadIcon />
                            </FlexRow>
                        )}

                        <FlexRow onClick={() => navigate(`/settlements/settlementResult?projectId=${record.projectId}&from=${record.from}&to=${record.to}`)}>
                             <DotsIcon />
                        </FlexRow>
                    </Space>
                )
            }
        ]} keyExtractor={(record) => (record.id || record.projectId).toString()} />
    )
}

export default ProjectSettlementList
